require('./app.less');
require('./vendor-dll-globals-fix.js');

var $ = require('jquery');

require('datatable-common-styles.less');
require('coolfit/datatables/datatables-processing');

require('select2-bootstrap-theme');
$.fn.select2.defaults.set("theme", "bootstrap");

var hb = require('handlebars/dist/handlebars.runtime.js');

$('.text').html(function (i, html) {
    var chars = $.trim(html).split("");

    return '<span>' + chars.join('</span><span>') + '</span>';
});


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app.js
// module id = 0
// module chunks = 1